module.exports = __webpack_public_path__ + "img/9.da0a8f37.jpg";